(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    function legacyInitPreorderButtons() {
  document.querySelectorAll('[data-legacy-preorder]').forEach(button => {
    if (button.dataset.preorderObserved) return;
    button.dataset.preorderObserved = 'true';
    const label = button.querySelector('span');
    if (!label) return;
    const update = () => {
      if (label.textContent.trim() === window.variantStrings?.addToCart && !button.disabled) label.textContent = button.dataset.legacyPreorder;
    };
    new MutationObserver(update).observe(label, {childList:true, subtree:true});
    update();
  });
}
legacyInitPreorderButtons();
document.addEventListener('shopify:section:load', legacyInitPreorderButtons);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["legacy-collections-dropdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('legacy-collections-dropdown')) {
    customElements.define('legacy-collections-dropdown', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const disclosure = this.querySelector('details');
        const trigger = this.querySelector('summary');
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(this.closeTimer);
          disclosure.open = true;
        }, options);
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.closeTimer = setTimeout(() => { if (!this.contains(document.activeElement)) disclosure.open = false; }, 180);
        }, options);
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') { disclosure.open = false; trigger.focus(); }
        }, options);
        this.addEventListener('focusout', () => {
          requestAnimationFrame(() => { if (!this.contains(document.activeElement)) disclosure.open = false; });
        }, options);
        document.addEventListener('pointerdown', (event) => { if (!this.contains(event.target)) disclosure.open = false; }, options);
      }
      disconnectedCallback() { clearTimeout(this.closeTimer); this.controller?.abort(); this.controller = null; }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
